var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hse-monitoring',{attrs:{"boardId":434}})
}
var staticRenderFns = []

export { render, staticRenderFns }